import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import axios from 'src/api/Api';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_SHIPPING_METHODS_SUCCESS,
    GET_SHIPPING_METHODS_FAILURE,
} from '../actions';
import { convertObjectToQueryParams } from 'src/utils/util';

export default function* getShippingMethods(action) {
    const sapPartnerId = yield select(
        (state) =>
            state.consignmentAddReducer.consignmentAddDetails.accountId
                .accountId
    );
    // const billToShipToPartnerRole = localStorage.getItem('billToShipToPartnerRole')
    // const sapPartnerIdOtherUser = yield select(
    //      (state) => state.consignmentAddReducer.consignmentAddDetails.accountId.accountId
    //   );
    //  const sapPartnerIdJapanUser = yield select(
    //      (state) => state.consignmentAddReducer.consignmentAddDetails.billToId.billToNumber
    //  );
    //  const sapPartnerIdResult = function (){
    //      if(billToShipToPartnerRole == 'BILL_TO'){
    //          return sapPartnerIdJapanUser
    //      }
    //      else
    //      return sapPartnerIdOtherUser
    //  }
    // const sapPartnerId = sapPartnerIdResult()

    const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/surgery/shippingmethod?${convertObjectToQueryParams({
        ...action.payload,
        sapPartnerId,
    })}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);
        var resultValue = [];

        result.shipMethods.map((item) => {
            resultValue.push(
                Object.prototype.hasOwnProperty.call(item, 'attnLine')
                    ? { ...item }
                    : { ...item, attnLine: '' }
            );
        });

        yield put({
            type: GET_SHIPPING_METHODS_SUCCESS,
            payload: {
                data: resultValue,
                salesOrg: action.payload.salesOrg,
                showShippingMethods: result.isValuePresent,
            },
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_SHIPPING_METHODS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
